import { render, staticRenderFns } from "./DeviceParameters.vue?vue&type=template&id=c35c1d8c&scoped=true&"
import script from "./DeviceParameters.vue?vue&type=script&lang=js&"
export * from "./DeviceParameters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35c1d8c",
  null
  
)

export default component.exports